export const EXP_CANADA_ADDRESS = '800 - 1070 Douglas Street,\nVictoria, BC, V8W2C4' as const;
export const EXP_QUEBEC_ADDRESS = '1111 Bd Dr.-Frederik-Philips #601,\nSaint-Laurent, Quebec H4M 2X6' as const;
export const ZOOCASA_ADDRESS = '52 Church St Suite\n464 Toronto, ON M5C 2B5' as const;